import {useContext} from 'react';
import {
  PortalPopoutManagerContext,
  type PortalPopoutManagerContextValue,
} from '../PortalPopoutReduxContext';

// ----------------------------
// usePortalPopoutManager
// ----------------------------
export const usePortalPopoutManager = (): PortalPopoutManagerContextValue => {
  const context = useContext(PortalPopoutManagerContext);

  if (!context) {
    throw new Error(
      'usePortalPopoutManager must be used within a PortalPopoutManager. ' +
        'Wrap your component tree with <PortalPopoutManager>.'
    );
  }

  return context;
};

export default usePortalPopoutManager;
